
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 477.5 477.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M407.5 69.9c-93.2-93.2-244.4-93.2-337.6 0s-93.2 244.4 0 337.6 244.4 93.2 337.6 0 93.3-244.3 0-337.6zm-17.6 320c-40 40.2-94.4 62.8-151.1 62.6C120.9 452.5 25 356.6 25 238.7 25 120.7 120.7 25 238.7 25c118 0 213.7 95.7 213.7 213.7.1 56.7-22.5 111.1-62.5 151.2z"}}),_c('path',{attrs:{"d":"M282.1 161.8c17.1 0 24.5-9.1 24.5-18.5 0-4.3-1.7-4.6-8-4.6H179.9c-6.3 0-8 .3-8 4.6 0 6.3 3.7 12 12.5 14.8h3.7v172.3c0 8.5 1.7 10 10.3 10h97.4c7.7 0 9.1-1.4 9.1-8.8v-5.7c0-7.1-1.4-8.5-9.1-8.5h-80.9V247h51c17.1 0 24.5-9.1 24.5-18.5 0-4.3-1.7-4.6-8-4.6h-67.5v-62.1h67.2z"}})])
          )
        }
      }
    